// [Vue migration] need to use global Highcharts instance to access all global settings
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
export default Highcharts;
